import { render, staticRenderFns } from "./AgeDemographicChart.vue?vue&type=template&id=82a47a8e"
import script from "./AgeDemographicChart.vue?vue&type=script&lang=js"
export * from "./AgeDemographicChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports